import _ from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { CrossIcon } from "../../components/icons/CrossIcon";
import { GlassIcon } from "../../components/icons/GlassIcon";
import { useQueryParams } from "../../hooks/useQueryParams";

interface Props {
  label?: React.ReactNode;
  placeholder?: string;
}

const TableSearch: React.FC<Props> = ({
  label = "Search all API keys",
  placeholder,
}) => {
  const { search } = useLocation();
  const { queryValue, handleChange } = useQueryParams({
    queryStr: "s",
  });

  const [searchValue, setSearchValue] = useState<string>(queryValue || "");

  const handleClearSearch = () => {
    setSearchValue("");
    handleChange("", true);
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedOnChange = useCallback(
    _.debounce(value => {
      handleChange(value, true);
    }, 1000),
    [search, _.debounce],
  );

  const handleSearch = (e: React.FormEvent<HTMLInputElement>) => {
    setSearchValue(e.currentTarget.value);
    debouncedOnChange(e.currentTarget.value);
  };

  useEffect(() => {
    if (queryValue !== searchValue) {
      setSearchValue(queryValue || "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryValue, setSearchValue]);

  return (
    <div className="card-title wrap-next-line mb-md-0 mb-8">
      <div className="search-input-wrapper position-relative my-1">
        <GlassIcon customClass="svg-search-icon svg-icon-1 position-absolute ms-5" />
        <input
          type="text"
          className="form-control form-control-solid ps-12 custom-search-input"
          value={searchValue}
          onChange={handleSearch}
          placeholder={placeholder || "Type to filter..."}
        />
        {searchValue && (
          <div
            className="search-cross-icon-wrapper"
            onClick={handleClearSearch}
            data-testid="clear-search-button"
          >
            <CrossIcon customClass="search-cross-icon" />
          </div>
        )}
      </div>
      <div className="short-explanation w-100">{label}</div>
    </div>
  );
};

export { TableSearch };
